<template>
  <div v-if="isManager || isAssistant" class="mt-3">
    <div class="text-end mb-2">
      <button
        class="btn btn-sm btn-info rounded-pill"
        title="Reiniciar Medição"
        @click="restartMeasure"
      >
        Reiniciar Medição
      </button>
    </div>
    <ValidateCertificateAteg
      v-if="step === 'ValidateCertificateAteg'"
      :contractId="contract.idContrato"
      @forwardCertificateValidationAteg="forwardCertificateValidationAteg"
    />
    <ValidateCertificateLocal
      v-if="step === 'ValidateCertificateLocal'"
      :documents="documents"
      :documentsExpireds="documentsExpireds"
      :requiredCertificates="measure.requiredCertificates"
      @forwardCertificateValidationLocal="forwardCertificateValidationLocal"
    />
    <UploadXmlFile
      v-if="step === 'UploadXMLFile'"
      :ategPcTecXmlNF="ategPcTecXmlNF"
      :ategPcTecPdfNF="ategPcTecPdfNF"
      @forwardXMLReader="forwardXMLReader"
    />
    <MeasureItensContract
      v-if="step === 'MeasureItens'"
      :contractId="contract.idContrato"
      :noteValue="measure.noteValue"
      :noteValueNet="measure.noteValueNet"
      :xmlJustify="measure.xmlJustify"
      :disableButtonSaveMeasure="disableButtonSaveMeasure"
      @fowardToSaveMeasure="fowardToSaveMeasure"
    />
  </div>
  <p v-else class="text-center mt-3 mb-0">
    Seu perfil não permite criar medições
  </p>
</template>

<script>
import ValidateCertificateAteg from '@/components/documents/contracts/ValidateCertificateAteg.vue'
import ValidateCertificateLocal from '@/components/documents/contracts/ValidateCertificateLocal.vue'
import UploadXmlFile from '@/components/documents/commons/UploadXmlFile.vue'
import MeasureItensContract from '@/components/documents/contracts/MeasureItensContract.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'NewMeasureContract',

  props: {
    contract: {
      type: Object,
      required: true,
    },
    documents: {
      type: Array,
      required: true,
    },
    documentsExpireds: {
      type: Array,
      required: true,
    },
  },

  components: {
    ValidateCertificateAteg,
    ValidateCertificateLocal,
    UploadXmlFile,
    MeasureItensContract,
  },

  data() {
    return {
      step: 'ValidateCertificateAteg',
      measure: {
        providerName: this.contract.contratado,
        dueDate: null,
        doValidadeAteg: null,
        ategPcTecId: null,
        requiredCertificates: this.contract.validaCertidao === 'T',
        needLocalCertificate: null,
        justifyCertificate: '',
        xml: null,
        typeOfPayment: null,
        noteValue: null,
        noteValueNet: null,
        valueTotal: 0,
        xmlJustify: '',
        jsonFile: null,
        selectedItens: [],
        attach: [],
        fileNames: [],
        ategAutoApprove: null,
      },
      ategPcTecXmlNF: null,
      ategPcTecPdfNF: null,
      disableButtonSaveMeasure: false,
    }
  },

  computed: {
    ...mapGetters(['isManager', 'isAssistant', 'useSeven']),
  },

  methods: {
    restartMeasure() {
      this.step = ''
      setTimeout(() => {
        this.step = 'ValidateCertificateAteg'
        this.measure = {
          providerName: this.contract.contratado,
          dueDate: null,
          doValidadeAteg: null,
          typeMeasure: '',
          ategPcTecId: null,
          requiredCertificates: this.contract.validaCertidao === 'T',
          needLocalCertificate: null,
          justifyCertificate: '',
          xml: null,
          typeOfPayment: null,
          noteValue: null,
          noteValueNet: null,
          valueTotal: 0,
          xmlJustify: '',
          jsonFile: null,
          selectedItens: [],
          attach: [],
          fileNames: [],
          ategAutoApprove: null,
        }
        this.ategPcTecXmlNF = null
        this.ategPcTecPdfNF = null
      }, 200)
    },

    forwardCertificateValidationAteg(data) {
      this.step = data.step
      this.measure.typeMeasure = data.typeMeasure
      this.measure.ategPcTecId = data.ategPcTecId
      this.measure.doValidadeAteg = data.validateResult
      this.ategAutoApprove = data.ategAutoApprove
      if (data.validateResult) {
        if (data.ategPcTecXmlNF.file) {
          this.ategPcTecXmlNF = data.ategPcTecXmlNF
        }
        if (data.ategPcTecPdfNF.file) {
          this.ategPcTecPdfNF = data.ategPcTecPdfNF
        }
      }
    },

    forwardCertificateValidationLocal(data) {
      this.step = 'UploadXMLFile'
      this.measure.needLocalCertificate = data.needJustify
      this.measure.justifyCertificate = data.justifyCertificate
    },

    forwardXMLReader(data) {
      this.step = 'MeasureItens'
      this.measure.dueDate = data.dueDate
      this.measure.xml = data.xml
      this.measure.typeOfPayment = data.typeOfPayment
      this.measure.noteValue = data.noteValue
      this.measure.noteValueNet = data.noteValueNet
      this.measure.xmlJustify = data.xmlJustify
      this.measure.jsonFile = data.jsonFile
      this.measure.attach = data.attach
      this.measure.fileNames = data.fileNames
    },

    fowardToSaveMeasure(data) {
      this.measure.totalValue = data.totalValue
      this.measure.selectedItens = data.selectedItens
      this.saveMeasure()
    },

    async saveMeasure() {
      try {
        this.disableButtonSaveMeasure = true

        const formData = new FormData()
        formData.append('contractId', this.contract.idContrato)
        formData.append('contractNumber', this.contract.numero)
        formData.append('providerName', this.measure.providerName)
        formData.append('dueDate', this.measure.dueDate)
        formData.append(
          'doValidadeAteg',
          this.measure.doValidadeAteg ? 'T' : 'F',
        )
        formData.append('typeMeasure', this.measure.typeMeasure)
        formData.append('ategPcTecId', this.measure.ategPcTecId)
        formData.append(
          'requiredCertificates',
          this.measure.requiredCertificates,
        )
        formData.append(
          'needLocalCertificate',
          this.measure.needLocalCertificate ? 'T' : 'F',
        )
        formData.append('justifyCertificate', this.measure.justifyCertificate)
        formData.append('xml', this.measure.xml)
        formData.append(
          'typeOfPayment',
          JSON.stringify(this.measure.typeOfPayment),
        )
        formData.append('noteValue', this.measure.noteValue)
        formData.append('noteValueNet', this.measure.noteValueNet)
        formData.append('totalValue', this.measure.totalValue)
        formData.append('xmlJustify', this.measure.xmlJustify)
        formData.append('jsonFile', JSON.stringify(this.measure.jsonFile))
        formData.append(
          'selectedItens',
          JSON.stringify(this.measure.selectedItens),
        )
        const recalculateTotalValue = this.measure.selectedItens.reduce(
          (acc, item) => acc + item.totalValue,
          0,
        )
        formData.append('totalValue', recalculateTotalValue)
        formData.append('attach', JSON.stringify(this.measure.attach))
        formData.append('fileNames', JSON.stringify(this.measure.fileNames))
        formData.append('ategAutoApprove', this.measure.ategAutoApprove)

        const response = await this.$store.dispatch(
          'saveContractMeasure',
          formData,
        )

        this.$emit('getMeasures')
        this.restartMeasure()
        this.$root.$refs.notification.success(response.message)
        this.disableButtonSaveMeasure = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    if (
      !this.useSeven ||
      (this.useSeven && !this.contract.codCentroCusto.startsWith('1.26'))
    ) {
      const params = {
        step: 'ValidateCertificateLocal',
        ategPcTecId: null,
        validateResult: false,
        ategAutoApprove: false,
        ategPcTecXmlNF: null,
        ategPcTecPdfNF: null,
      }
      this.forwardCertificateValidationAteg(params)
    }
  },
}
</script>
